import { WAREHOUSE_TYPES } from '../constants'

export const getFacilityTypeLabel = (type?: string | null) => {
  return WAREHOUSE_TYPES.find(t => t.value === type)?.label || ''
}
